<template>
  <header class="header">
    <div class="left-section">
      <div class="sidebar-toggle" @click="toggleSidebar">
        <i class="fa-solid fa-bars"></i>
      </div>
      <!-- <div class="logo">
        <i class="fa-solid fa-cube"></i>
        <span>管理系统</span>
      </div> -->
    </div>
    
    <!-- <ul class="top-menu">
      <li 
        v-for="menu in topMenus" 
        :key="menu.id"
        class="top-menu-item"
        :class="{ active: currentTopMenu === menu.id }"
        @click="switchMenu(menu)"
      >
        <i :class="menu.icon"></i>
        <span>{{ menu.name }}</span>
      </li>
    </ul> -->
    
    <div class="user-info" @click="toggleUserMenu" ref="userInfoRef">
      <div class="phone">
      <img src="../../assets/image/phone.png" alt="">
      <span @click="handlePerson">电话咨询</span>
      <!-- <a-popover title="">
        <template #content>
        <p>杨亮亮 15801410210</p>
        <p>胡念金 18010886137</p>
        <p>王琳珂 18860479608</p>
        </template>
        <span>电话咨询</span>
    </a-popover> -->
      </div>
      <div class="avatar">
         <img style="width: 45px;height: 45px;" src="../../assets/image/avatar.png" alt="">
      </div>
      <span @click="handleLogout">退出登录</span>
      <!-- 值班人员 -->
       <a-modal 
            v-model:visible="state.dialogVisible" 
             title=" " 
             @cancel="handleOk"
             :maskClosable="false"
             style="top: 8px;"
             @ok="handleOk"
             width="25%"
             wrap-class-name="full-modal"
            :getContainer="getContainer">
            <template #footer>
                <!-- <a-button key="back" type="primary" @click="handleOk">确定</a-button>
                <a-button key="back" @click="state.dialogVisible=false">取消</a-button> -->
            </template>
             <div class="sample-form">
                
                <a-table
                    :scroll="{ y: 480 }"
                    :loading="state.loading"
                    :columns="columns" 
                    :dataSource="state.tableData" 
                    @resizeColumn="handleResizeColumn"
                    :pagination="false"
                     :showHeader="false"
                    bordered>
                        <!-- <template v-slot:headerCell="{title, column}">
                            <div>{{ title }}</div>
                            <div v-if="column.key=='reportGcbh'">
                                 <a-input  v-model:value="state.searchForm.reportGcbh" @input="getList" allow-clear placeholder="请输入"></a-input>
                            </div>
                            <div v-if="column.key=='projectName'">
                                 <a-input  v-model:value="state.searchForm.projectName" @input="getList" allow-clear placeholder="请输入"></a-input>
                            </div>


                        </template> -->
                        <template v-slot:bodyCell="{text, record, index, column}">
                            <span v-if="column.dataIndex=='typeName'">{{ record.typeName }}</span>
                        </template>

                </a-table>
                 <div class="phone2">
                    <p> 
                       <span style="font-weight: bold;">市场开发部：</span>
                       <span style="margin-right: 10px;">0551-62610218</span>
                       <span>15077926385</span>
                    </p>
                    <p>
                       <span style="font-weight: bold;">生产安全部：</span>
                       <span style="margin-right: 10px;">0551-68120852</span>
                       <span>13966716980</span>
                    </p>
                 </div>
            </div>
        </a-modal>
  
    </div>
  </header>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted,reactive } from 'vue';
import { MenuItem } from '@/types';
import { PaginationProps,Modal,message,Table,Row,Col,Button} from "ant-design-vue";
import { getToken, setToken,setRefreshToken, removeToken,removeRefreshToken } from '@/utils/auth'
import { useRouter } from 'vue-router';
import {getCurrentKfDayPlan} from "@/api/entrust"
const router = useRouter();
const emit = defineEmits(['menu-change', 'toggle-sidebar']);
const userInfoRef = ref<HTMLElement | null>(null);

const currentTopMenu = ref('dashboard');
const isUserMenuOpen = ref(false);

const topMenus: MenuItem[] = [
  { id: 'dashboard', name: '仪表板', icon: 'fa-solid fa-gauge-high', path: '/dashboard' },
  { id: 'content', name: '内容管理', icon: 'fa-solid fa-file-lines', path: '/content' },
  { id: 'users', name: '用户管理', icon: 'fa-solid fa-users', path: '/users' },
  { id: 'analytics', name: '数据分析', icon: 'fa-solid fa-chart-simple', path: '/analytics' },
  { id: 'settings', name: '系统设置', icon: 'fa-solid fa-gear', path: '/settings' }
];

const userMenuItems= [
  { id: 'logout', name: '退出登录', icon: 'fa-solid fa-right-from-bracket' }
];
const columns = ref<any>([
    {
        title: '单位',
        dataIndex: 'typeName',
        key: 'typeName',
        resizable:true,
        width:20,
        searchable:true,
        formType:'input',
        align:'center'
      
    },
    {
        title: '联系电话',
        dataIndex: 'mobilePhone',
        key: 'mobilePhone',
        searchable:true,
        formType:'input',
        width:20,
        align:'center'
    }
 
])
const state = reactive({
    dialogVisible:false,
    loading:false,
    tableData:[]
})
const handleResizeColumn = (w,col)=>{
    col.width = w;
}
const handlePerson = ()=>{
  state.dialogVisible = true
}
const handleOk = ()=>{
  state.dialogVisible = false
}
// 获取人员
const getCurrentPerson = async()=>{
  const res = await getCurrentKfDayPlan()
  if(res.code=='1'){
      state.tableData = res.data
  }
  
}
getCurrentPerson()
const switchMenu = (menu: MenuItem) => {
  currentTopMenu.value = menu.id;
  emit('menu-change', menu);
};

const toggleSidebar = () => {
  emit('toggle-sidebar');
};

const toggleUserMenu = () => {
  isUserMenuOpen.value = !isUserMenuOpen.value;
};

const handleUserMenuAction = (item) => {
  if (item.id === 'logout') {
    handleLogout();
  } else if (item.id === 'profile') {
    router.push('/profile');
  } else if (item.id === 'settings') {
    router.push('/settings/account');
  }
  // 关闭菜单，除非是分隔线
  if (item.id !== 'divider') {
    isUserMenuOpen.value = false;
  }
};
const getContainer = ()=>{
    return document.body
}
const handleLogout = () => {
  Modal.confirm({
            title: '提示',
            content: '确定注销并退出系统吗？',
            getContainer: getContainer,
            okText: '确定',
            cancelText: '取消',
            onOk() {
                return new Promise((resolve, reject) => {
                    localStorage.clear();
                    sessionStorage.clear();
                    removeToken();
                    removeRefreshToken()
                    router.replace({path:'/login'});
                    Modal.destroyAll();
                    // location.reload();
                })
                   

            },
      
            onCancel() {
                return new Promise((resolve, reject) => {
                    Modal.destroyAll();
                })
                
            },
      });
};

// 点击外部关闭用户菜单
const handleClickOutside = (event: MouseEvent) => {
  if (userInfoRef.value && !userInfoRef.value.contains(event.target as Node)) {
    isUserMenuOpen.value = false;
  }
};

onMounted(() => {
  document.addEventListener('click', handleClickOutside);
});

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside);
});
</script>

<style lang="less" scoped>
@import '@/styles/variables.less';

.header {
  // background: linear-gradient(135deg, @primary-color, @secondary-color);
  // color: @text-light;
  padding: 0 20px;
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  margin-bottom: 10px;
  // box-shadow: @shadow;
  position: sticky;
  top: 0;
  z-index: 1000; // 提高z-index确保菜单在上层
}
.phone2{
  //  display: flex;
  margin-top: 20px;
  text-align: center;
  span{
    display: inline-block;
  }
  
}

.logo {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: bold;
  font-size: 1.5rem;
  
  i {
    color: @accent-color;
  }
}

.left-section {
  display: flex;
  align-items: center;
  gap: 15px;
}

.sidebar-toggle {
  cursor: pointer;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s ease;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
  
  i {
    font-size: 1.2rem;
  }
}

.top-menu {
  display: flex;
  list-style: none;
  gap: 5px;
}

.top-menu-item {
  padding: 10px 15px;
  border-radius: @border-radius;
  cursor: pointer;
  transition: @transition;
  position: relative;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
  
  &.active {
    background-color: rgba(255, 255, 255, 0.2);
    
    &::after {
      content: '';
      position: absolute;
      bottom: -2px;
      left: 0;
      width: 100%;
      height: 3px;
      background-color: @accent-color;
      border-radius: 3px 3px 0 0;
    }
  }
}

.user-info {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  position: relative;
  padding: 5px 10px;
  border-radius: @border-radius;
  transition: background-color 0.3s ease;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
}

.avatar {
  
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: @light-color;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: @primary-color;
  margin-right: 16px;
}
.phone {
  margin-right: 40px;
  img{
    margin-right: 10px;
  }
}


.user-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background-color: white;
  border-radius: @border-radius;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 160px;
  z-index: 1001;
  margin-top: 10px;
  overflow: hidden;
  color:#666;
  
  &::before {
    content: '';
    position: absolute;
    top: -6px;
    right: 20px;
    width: 12px;
    height: 12px;
    background-color: white;
    transform: rotate(45deg);
  }
}

.user-menu-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  color: @text-color;
  transition: background-color 0.3s ease;
  cursor: pointer;
  
  &:hover {
    background-color: #f5f7fa;
  }
  
  i {
    width: 16px;
    color: #666;
  }
  
  // 分隔线样式
  &[data-divider] {
    padding: 0;
    height: 1px;
    background-color: #eee;
    cursor: default;
    
    &:hover {
      background-color: #eee;
    }
  }
}

// 为分隔线项目添加特殊样式
.user-menu-item:has(+ .user-menu-item[data-divider]),
.user-menu-item[data-divider] + .user-menu-item {
  border-top: 1px solid #eee;
}

@media (max-width: 768px) {
  .top-menu-item span {
    display: none;
  }
  
  .user-info span {
    display: none;
  }
  
  .logo span {
    display: none;
  }
  
  .left-section {
    gap: 10px;
  }
  
  .user-menu {
    right: -10px;
    min-width: 140px;
  }
}

@media (max-width: 480px) {
  .header {
    padding: 0 10px;
  }
  
  .top-menu {
    gap: 2px;
  }
  
  .top-menu-item {
    padding: 8px 10px;
  }
}
</style>